import { call, put, takeLatest } from "redux-saga/effects";
import deviceApi from "api/deviceApi";
import { deviceActions } from "./deviceSlice";
import { toast } from "react-toastify";

function* getDevicesSaga(action: any): Generator<any, void, any> {
  try {
    const response = yield call(deviceApi.getDevices, action.payload);
    yield put(deviceActions.getDevicesSuccess(response?.data || response));
  } catch (err: any) {
    const msg = err?.response?.data?.message || "Failed to fetch devices";
    yield put(deviceActions.getDevicesFail(msg));
    toast.error(msg);
  }
}

function* addDeviceSaga(action: any): Generator<any, void, any> {
  try {
    const response = yield call(deviceApi.addDevice, action.payload);
    const msg = response?.data?.message || "Device registered successfully";
    yield put(deviceActions.addDeviceSuccess(msg));
    toast.success(msg);
  } catch (err: any) {
    const msg = err?.response?.data?.message || "Failed to register device";
    yield put(deviceActions.addDeviceFail(msg));
    toast.error(msg);
  }
}

function* updateDeviceSaga(action: any): Generator<any, void, any> {
  try {
    const response = yield call(deviceApi.updateDevice, action.payload);
    const msg = response?.data?.message || "Device updated successfully";
    yield put(deviceActions.updateDeviceSuccess(msg));
    toast.success(msg);
  } catch (err: any) {
    const msg = err?.response?.data?.message || "Failed to update device";
    yield put(deviceActions.updateDeviceFail(msg));
    toast.error(msg);
  }
}

function* deleteDeviceSaga(action: any): Generator<any, void, any> {
  try {
    const response = yield call(deviceApi.deleteDevice, action.payload);
    const msg = response?.data?.message || "Device deleted successfully";
    yield put(deviceActions.deleteDeviceSuccess(msg));
    toast.success(msg);
  } catch (err: any) {
    const msg = err?.response?.data?.message || "Failed to delete device";
    yield put(deviceActions.deleteDeviceFail(msg));
    toast.error(msg);
  }
}

export function* deviceSaga() {
  yield takeLatest(deviceActions.getDevices.type, getDevicesSaga);
  yield takeLatest(deviceActions.addDevice.type, addDeviceSaga);
  yield takeLatest(deviceActions.updateDevice.type, updateDeviceSaga);
  yield takeLatest(deviceActions.deleteDevice.type, deleteDeviceSaga);
}
